module.exports = __webpack_public_path__ + "img/arrow-club.20b8bdaf.svg";